
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import "@/store/modules/application";
const applicationState = namespace("Application");

import StepBase from "../StepBase.vue";
import AffidavitPersonalServicePo from "./AffidavitPersonalServicePO.vue";
import AboutAffiantApsp from "./AboutAffiantAPSP.vue";
import AboutServiceApsp from "./AboutServiceAPSP.vue";
import ElectronicFilingStatementApsp from "./ElectronicFilingStatementAPSP.vue";
import ReviewYourAnswersApsp from "./reviewAPSP/ReviewYourAnswersAPSP.vue";
import PreviewFormsApsp from "./reviewAPSP/PreviewFormsAPSP.vue";
import PreviewFormsApspEfsp from "./reviewAPSP/PreviewFormsApspEFSP.vue";

import { stepInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        StepBase,        
        AffidavitPersonalServicePo,        
        AboutAffiantApsp,
        AboutServiceApsp,
        ElectronicFilingStatementApsp,
        ReviewYourAnswersApsp,
        PreviewFormsApsp,
        PreviewFormsApspEfsp
    }
})
export default class AffidavitPersonalServicePoStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}
